import React, { useState, useEffect } from 'react';
import { Spin, Result, Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import api from '../services/api';

const CheckStatus = () => {
  const [loading, setLoading] = useState(true);
  const [status, setStatus] = useState(null);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    checkPaymentStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkPaymentStatus = async () => {
    try {
      const urlParams = new URLSearchParams(location.search);
      // Supports both the plan-purchase flow (transactionId) and the
      // generic Pay Now flow (merchantOrderId).
      const transactionId = urlParams.get('transactionId') || urlParams.get('merchantOrderId');

      if (!transactionId) {
        setStatus('error');
        setMessage('No transaction ID found');
        setLoading(false);
        return;
      }

      // Add a small delay to ensure payment is processed
      await new Promise(resolve => setTimeout(resolve, 2000));

      const response = await api.get(`/user/payment-status/${transactionId}`);

      if (response.data.success && response.data.status === 'SUCCESS') {
        setStatus('success');
        setMessage(response.data.data?.planActivated 
          ? 'Payment successful! Your plan has been activated.'
          : 'Payment completed successfully!');
      } else if (response.data.status === 'PENDING') {
        setStatus('info');
        setMessage('Payment is being processed. This may take a few minutes.');
        
        // Check again after 10 seconds if still pending
        setTimeout(() => {
          if (loading) {
            checkPaymentStatus();
          }
        }, 10000);
        return; // Don't set loading to false yet
      } else {
        setStatus('error');
        setMessage(response.data.message || 'Payment failed. Please try again.');
      }
    } catch (error) {
      console.error('Error checking payment status:', error);
      setStatus('error');
      setMessage('Error verifying payment status. Please contact support if payment was completed.');
    } finally {
      setLoading(false);
    }
  };

  const goToDashboard = () => {
    navigate('/dashboard');
  };

  const goToPlans = () => {
    navigate('/plans');
  };

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '100vh',
        flexDirection: 'column',
        gap: '20px'
      }}>
        <Spin size="large" />
        <h3>Verifying your payment...</h3>
        <p>Please wait while we confirm your transaction.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <Result
        status={status}
        title={status === 'success' ? 'Payment Successful!' : 
               status === 'info' ? 'Payment Processing' : 
               'Payment Failed'}
        subTitle={message}
        extra={[
          status === 'success' ? (
            <Button type="primary" key="dashboard" onClick={goToDashboard}>
              Go to Dashboard
            </Button>
          ) : status === 'info' ? (
            <Button key="refresh" onClick={checkPaymentStatus}>
              Check Again
            </Button>
          ) : (
            <Button type="primary" key="retry" onClick={goToPlans}>
              Try Again
            </Button>
          )
        ]}
      />
    </div>
  );
};

export default CheckStatus;